<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13cKnR3/media/FC-9781398494848.jpg?1733711378715" alt="This image is the cover for the book The Reluctant Outsider"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Reluctant Outsider
      </h1>
      <p class="bookDescription body article font2">
        <p>This is the story of a life that took an unexpected turn, leading to priceless treasures and profound awakenings. George Dexton’s journey begins with the decision to emigrate to a distant land, followed by the commitments of marriage, raising a family, and starting a new business. As he battles for success and recognition, George’s marriage collapses, plunging him into a period of overindulgence and recklessness that eventually leads to the downfall of his business. In the aftermath, an unexpected mystical experience brings confusion, spiraling George into depression and a deep philosophical quest. He explores the unknown depths of his mind, searching for meaning and freedom from what feels like a futile existence. Reluctantly pushing forward, he reaches a point of no return, still seeking a sense of purpose in a world that seems blind to his struggles.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beverley Charles Foster
      </h2>
      
      <p class="authorDescription body article">Beverley Charles Foster grew up and was educated in Yorkshire. His one great ambition in those days was to become a professional footballer, but after leaving school, he managed to arrange a trial at Hull City AFC. But Beverley failed to make the grade and so drifted in and out of dull jobs until he got the opportunity to travel to Africa where Beverley opened his own clothing business. He has four children and now lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3839d5e9